import React from "react";
import { withRouter } from "react-router-dom";
import FirstStep from "./components/FirstStep";
import SecondStep from "./components/SecondStep";
import ThirdStep from "./components/ThirdStep";
import {
  getCookieToken,
  makeRequestAuth,
  validateEmail,
} from "../../utils/globals";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import ImageLoader from "../../components/ImageLoader";
import axios from "axios";
import config from "config";
import profileService from "../../services/profileService";
const url = config.storeFrontUrl.replace(/\/$/g, "");
import styled from "styled-components";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import { Icon } from "@plum-xoxo/admin-dsm";

const BlueSpan = styled.span`
  color: ${(props) => props.theme.palette.primary.c03};
`;

const StyledBackground = styled.div.attrs()`
  background: #ffffff;
`;
class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.emailInputRef = React.createRef();
    this.state = {
      userDetails: {
        phoneCode: {
          country_id: 99,
          iso: "IN",
          label: "IN +91",
          name: "India",
          phonecode: "+91",
          value: 99,
        },
      },
      error: {},
      currentStep: 1,
      signupLoader: false,
      OTP: "",
      api_call: false,
      load_resume_link: false,
      country_name: "",
      width: 0,
      height: 0,
      renderTurnstileCaptcha: false,
      showCts: true,
      isEmailChangeClicked: false,
      domainExists: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    let url = window.location.href;
    if (url[url.length - 1] === "/") {
      this.props.history.push(`/${config.app_path}/signup`);
    }
    axios.get("https://ipapi.co/json/").then((response) => {
      this.setState({ country_name: response.data.country_code });
    });
    if (
      this.props.location &&
      this.props.location.search != "" &&
      this.props.location.search.indexOf("resume_link") != -1
    ) {
      let get_resume = this.props.location.search.split("resume_link=")[1];
      this.getResumeLink(get_resume);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    if (window.innerWidth < 1024 && window.innerHeight < 2340) {
      window.location = "https://www.xoxoday.com/signup/sign-up-for-xoxoday";
    }
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  updateState = (data) => {
    typeof data === "object" ? this.setState(data) : null;
  };

  generateCfToken = () => {
    this.setState({ signupLoader: true, renderTurnstileCaptcha: true });
    if (this.handleValidation()) {
      this.setState({ renderTurnstileCaptcha: true });
    } else {
      this.setState({ signupLoader: false });
    }
  };

  handleValidation() {
    let fields = this.state.userDetails;
    let error = {};
    let formIsValid = true;
    var strongRegex = new RegExp(
      "^(?!.* )(?=.*[$&+,:;=?@#|'<>.^*()%!-])(?=.*[0-9])(?=.{8,})"
    );

    if (Object.keys(fields).length == 0) {
      formIsValid = false;
      error["all_fileds"] = "* All the above fields are mandatory.";
    } else {
      if (!fields["firstname"]) {
        formIsValid = false;
        error["firstname"] = "Please enter your name";
      }
      if (!fields["company_name"]) {
        formIsValid = false;
        error["company_name"] = "Please enter a company name";
      }

      if (!fields["email"]) {
        formIsValid = false;
        error["email"] = "Please enter a valid company email.";
      }

      if (typeof fields["email"] !== "undefined") {
        if (validateEmail(fields["email"])) {
          const lastAtPos = fields["email"].lastIndexOf("@");
          const lastDotPos = fields["email"].lastIndexOf(".");
          const re = /.+@(gmail|yahoo)\.com$/;

          if (
            !(
              lastAtPos < lastDotPos &&
              lastAtPos > 0 &&
              fields["email"].indexOf("@@") == -1 &&
              lastDotPos > 2 &&
              fields["email"].length - lastDotPos > 2
            )
          ) {
            formIsValid = false;
            error["email"] = "Please enter a valid company email.";
          } else if (fields["email"].match(re)) {
            formIsValid = false;
            error["email"] = "Only work email is allowed";
          }
        } else {
          formIsValid = false;
          error["email"] = "Please enter a valid company email.";
        }
      }

      if (!fields["pwd"]) {
        formIsValid = false;
        error["pwd"] = "Please enter a password";
      }

      if (
        typeof fields["pwd"] !== "undefined" &&
        !fields["pwd"].match(strongRegex)
      ) {
        formIsValid = false;
        error["pwd"] =
          "Password must contain atleast 8 characters, 1 numeric and 1 special character";
      }
    }
    this.setState({ error: error });
    return formIsValid;
  }

  signUpFlow = (token = "", checkDomain = false) => {
    this.setState({ signupLoader: true, renderTurnstileCaptcha: false });
    const { userDetails, country_name } = this.state;
    const nameSplit = userDetails.firstname.split(" ");
    const firstName = nameSplit[0];
    const lastName = nameSplit.slice(1, nameSplit.length).join(" ");
    const utkData = getCookieToken("hubspotutk");
    const query = "diy.mutation.validate_email_plum_diy";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        email: this.state.userDetails.email,
        firstname: firstName,
        pwd: this.state.userDetails.pwd,
        lastname: lastName,
        company_name: this.state.userDetails.company_name,
        hubspotutk: utkData,
        country_name: country_name,
        contact: this.state.userDetails.phoneNumber
          ? `${this.state.userDetails.phoneCode?.phonecode}-${this.state.userDetails?.phoneNumber}`
          : "",
        token,
        checkDomain,
      },
    };

    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.validateEmailPlumDIY &&
          response.data.validateEmailPlumDIY.domainExists
        ) {
          this.setState({
            signupLoader: false,
            domainExists: true,
          });
        } else if (
          response &&
          response.data &&
          response.data.validateEmailPlumDIY &&
          response.data.validateEmailPlumDIY.success == 1
        ) {
          this.setState({
            signupLoader: false,
            diy_uuid: response.data.validateEmailPlumDIY.diy_uuid,
            currentStep: this.state.currentStep + 1,
          });
        } else {
          if (
            response &&
            response.data &&
            response.data.validateEmailPlumDIY &&
            response.data.validateEmailPlumDIY.errcode === "038"
          ) {
            const error = {};
            error["email"] = "Only work email is allowed";
            this.setState({ error: error });
          } else if (
            response &&
            response.data &&
            response.data.validateEmailPlumDIY &&
            response.data.validateEmailPlumDIY.userExists
          ) {
            const error = {};
            let errormsg = (
              <Typography.HelperText color={"red"} shade="200">
                This email id already exists.{" "}
                <a
                  href={url + "/marketplace/login"}
                  style={{ textDecoration: "underline" }}
                >
                  <BlueSpan>Click here to login</BlueSpan>
                </a>
              </Typography.HelperText>
            );
            error["email"] = errormsg;
            this.setState({ error: error });
          } else {
            NotificationManager.error(
              (response.data.validateEmailPlumDIY &&
                response.data.validateEmailPlumDIY.errmsg) ||
                "Something went wrong"
            );
          }

          this.setState({
            create_lbr: false,
            eventLoader: false,
            signupLoader: false,
          });
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  validOTpMail = () => {
    this.setState({ api_call: true });
    const query = "diy.mutation.validate_otp_plum_diy";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        email: this.state.userDetails.email,
        OTP: this.state.OTP,
        diy_uuid: this.state.diy_uuid,
      },
    };

    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.validateOTPUser &&
          response.data.validateOTPUser.success == 1
        ) {
          this.setState({
            currentStep: this.state.currentStep + 1,
            diy_uuid: response.data.validateOTPUser.diy_uuid,
            api_call: false,
          });
        } else {
          let error = this.state.error;
          error["invalid_otp"] =
            response.data &&
            response.data.validateOTPUser &&
            response.data.validateOTPUser.errmsg ? (
              <Typography component="div" className="d-flex">
                <Typography component="div">
                  <Icon color="red" shade="c300" iconName="Close" size="20" />
                </Typography>
                <Typography
                  component="div"
                  color="red"
                  shade="c300"
                  className="ml-8"
                >
                  {response.data.validateOTPUser.errmsg}
                </Typography>
              </Typography>
            ) : (
              <Typography component="div" className="d-flex">
                <Typography component="div">
                  <Icon color="red" shade="c300" iconName="Close" size="20" />
                </Typography>
                <Typography
                  component="div"
                  color="red"
                  shade="c300"
                  className="ml-8"
                >
                  Something went wrong
                </Typography>
              </Typography>
            );
          this.setState({ api_call: false, error, OTP: "" });
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  resendOTP = (token = "") => {
    let error = this.state.error;
    error["invalid_otp"] = "";
    this.setState({ error });
    const query = "diy.mutation.resend_diy_store_otp";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        email: this.state.userDetails.email,
        diy_uuid: this.state.diy_uuid,
        token,
      },
    };

    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.resendDIYStoreOtp &&
          response.data.resendDIYStoreOtp.success == 1
        ) {
          /* empty */
        } else {
          NotificationManager.error(
            (response.data.resendDIYStoreOtp &&
              response.data.resendDIYStoreOtp.errmsg) ||
              "Something Went Wrong"
          );
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  getResumeLink = (link) => {
    this.setState({ load_resume_link: true });
    const query = "diy.query.diy_validate_resume_link";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        diy_resume_link: link,
      },
    };

    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.getResumeVerification &&
          response.data.getResumeVerification.success == 1
        ) {
          let respons = response.data.getResumeVerification;
          let userDetail = this.state.userDetails;
          userDetail["email"] = respons.email;
          this.setState({
            userDetails: userDetail,
            diy_uuid: respons.diy_uuid,
            currentStep: 3,
            load_resume_link: false,
          });
        } else {
          this.setState({ load_resume_link: false });
          this.props.history.push({
            pathname: `/${config.app_path}/signup`,
          });
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  onOtpChange = (code) => {
    this.setState({ OTP: code, error: {} }, () => {
      if (code.length === 6) {
        this.validOTpMail();
      }
    });
  };

  backCurrentStep = (val) => {
    if (val) {
      this.setState({
        isEmailChangeClicked: true,
        domainExists: false,
        userDetails: { ...this.state.userDetails, email: "", pwd: "" },
      });
    }
    this.setState({ currentStep: this.state.currentStep - 1, error: {} });
  };

  changeCurrentStrp = () => {
    this.setState({ currentStep: this.state.currentStep + 1 });
  };

  handleEmailBlur = (email) => {
    this.setState({
      signupLoader: true,
    });
    const newError = this.state.error;
    if (!email) {
      newError["email"] = "Please enter your email.";
      this.setState({
        error: newError,
        signupLoader: false,
      });
      return;
    }
    const payload = {
      user_input: email,
      source: "admin",
    };
    email &&
      profileService.getUserAssoc(payload).then((res) => {
        const data = res.data.getUserAssocAcc;

        let errorMsg;

        if (
          data.errmsg === "xoxocodeUser" ||
          data.errmsg === "xoxoCodeAndPointUser"
        ) {
          errorMsg = (
            <Typography.HelperText color={"red"} shade="200">
              It seems you are an existing user looking to redeem xoxocode.{" "}
              <a href={url + "/marketplace/vouchers"}>
                <BlueSpan>Click here</BlueSpan>
              </a>{" "}
              to go to stores.
            </Typography.HelperText>
          );
        } else if (data.errmsg === "xoxopointUser") {
          errorMsg = (
            <Typography.HelperText color={"red"} shade="200">
              It seems you are an existing user looking to redeem xoxopoints.{" "}
              <a href={url + "/marketplace/login"}>
                <BlueSpan>Click here to login</BlueSpan>
              </a>
            </Typography.HelperText>
          );
        } else if (data.errmsg === "userAlreadyExists") {
          errorMsg = (
            <Typography.HelperText color={"red"} shade="200">
              This email id already exists.
              <a href={url + "/marketplace/login"}>
                <BlueSpan>Click here to Login</BlueSpan>
              </a>
            </Typography.HelperText>
          );
        } else if (data.errmsg === "disposableEmail") {
          errorMsg = (
            <Typography.HelperText color={"red"} shade="200">
              Invalid email. Please provide a valid email address.
            </Typography.HelperText>
          );
        }
        if (errorMsg) {
          newError["email"] = errorMsg;
        }
        this.setState({
          error: newError,
          showCts: data.showCts,
          signupLoader: false,
        });
      });
  };

  render() {
    const {
      userDetails,
      error,
      currentStep,
      signupLoader,
      renderTurnstileCaptcha,
      showCts,
    } = this.state;
    return (
      <div
        style={{
          display:
            window.innerWidth < 1024 && window.innerHeight < 2340 ? "none" : "",
        }}
      >
        <StyledBackground>
          {!this.state.load_resume_link ? (
            <div className="sign-up" id="signup">
              <div
                className={`rightContainer  ${
                  currentStep === 1 || currentStep === 2 ? "--stepOne " : ""
                }`}
              >
                {currentStep === 1 || currentStep === 2 ? (
                  <FirstStep
                    renderTurnstileCaptcha={renderTurnstileCaptcha}
                    userDetails={userDetails}
                    error={error}
                    updateState={this.updateState}
                    changeStep={(checkDomain = false) => {
                      if (showCts) {
                        this.generateCfToken();
                      } else {
                        this.signUpFlow("", checkDomain);
                      }
                    }}
                    signupLoader={signupLoader}
                    history={this.props.history}
                    handleEmailBlur={this.handleEmailBlur}
                    signUpFlow={(token, checkDomain) =>
                      this.signUpFlow(token, checkDomain)
                    }
                    isEmailChangeClicked={this.state.isEmailChangeClicked}
                    emailInputRef={this.emailInputRef}
                    domainExists={this.state.domainExists}
                  />
                ) : null}

                {currentStep === 2 || currentStep === 1 ? (
                  <SecondStep
                    showCts={showCts}
                    email={this.state.userDetails.email}
                    resendOTP={(token) => this.resendOTP(token)}
                    OTP={this.state.OTP}
                    onOtpChange={this.onOtpChange}
                    validOTpMail={this.validOTpMail}
                    api_call={this.state.api_call}
                    error={error}
                    currentStep={currentStep}
                    backCurrentStep={this.backCurrentStep}
                  />
                ) : null}

                {currentStep === 3 || currentStep === 4 ? (
                  <ThirdStep
                    getRewardType={this.getRewardType}
                    email={this.state.userDetails.email}
                    phoneNumber={this.state.userDetails.phoneNumber}
                    isd_code_object={this.state.userDetails.phoneCode}
                    diy_uuid={this.state.diy_uuid}
                    currentStep={currentStep}
                    updateCurrent={this.changeCurrentStrp}
                    history={this.props.history}
                  />
                ) : null}
              </div>
              <NotificationContainer />
            </div>
          ) : (
            <ImageLoader />
          )}
        </StyledBackground>
      </div>
    );
  }
}

export default withRouter(SignUp);
